import { put, call, takeEvery } from 'typed-redux-saga';
import GoldGateway from '~apis/gold';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldConversionStatusEnum } from '~utils/enums';

export default function* watchGetPendingGoldConversionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingGoldConversionListingAttempt', handleGetPendingGoldConversionListing, api);
}

function* handleGetPendingGoldConversionListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            branchName,
            branchCode,
            productName,
            dateFrom,
            dateTo,
            metalType,
        },
    } = reduxState.approval.pendingGoldConversionListing;
    const allBranches = reduxState.branch.allBranches;

    const selectedBranch = allBranches.find(
        branch => branch.branchName === branchName || branch.branchCode === branchCode
    );

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingGoldConversionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getGoldConversionListing], {
        authToken,
        index,
        status: GoldConversionStatusEnum.Pending,
        branchId: selectedBranch ? String(selectedBranch.branchId) : undefined,
        branchCode,
        productName,
        dateFrom,
        dateTo,
        metalType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingGoldConversionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingGoldConversionListingSuccess(response.data));
    }
}
